"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templateSourceTypes = exports.VIDEO_FILE = exports.SourceTypes = exports.SCREEN_PRESENTER = exports.S3SourceTypes = exports.PDF_FILE = exports.MEDIA = exports.LayerSourceTypes = exports.ItemTypes = exports.IMAGE_FILE = exports.DocSourceTypes = exports.CAMERA_PRESENTER = exports.BANNER = exports.AudioSourceTypes = exports.AUDIO_PRESENTER = exports.AUDIO_FILE = void 0;
var VIDEO_FILE = exports.VIDEO_FILE = 'videoFile';
var AUDIO_FILE = exports.AUDIO_FILE = 'audioFile';
var IMAGE_FILE = exports.IMAGE_FILE = 'imageFile';
var PDF_FILE = exports.PDF_FILE = 'pdfFile';
var CAMERA_PRESENTER = exports.CAMERA_PRESENTER = 'cameraPresenter';
var SCREEN_PRESENTER = exports.SCREEN_PRESENTER = 'screenPresenter';
var AUDIO_PRESENTER = exports.AUDIO_PRESENTER = 'audioPresenter';
var BANNER = exports.BANNER = 'banner';
var MEDIA = exports.MEDIA = 'media';
var AudioSourceTypes = exports.AudioSourceTypes = [AUDIO_FILE];
var LayerSourceTypes = exports.LayerSourceTypes = [CAMERA_PRESENTER, SCREEN_PRESENTER, VIDEO_FILE, IMAGE_FILE, PDF_FILE, BANNER, MEDIA];
var DocSourceTypes = exports.DocSourceTypes = [VIDEO_FILE, IMAGE_FILE, AUDIO_FILE, PDF_FILE];
var SourceTypes = exports.SourceTypes = LayerSourceTypes.concat(AudioSourceTypes);
var ItemTypes = exports.ItemTypes = {
  SOURCE: 'SOURCE',
  SCREEN_PRESENTER: 'SCREEN_PRESENTER'
};
var templateSourceTypes = exports.templateSourceTypes = new Set([IMAGE_FILE, VIDEO_FILE, AUDIO_FILE]);
var S3SourceTypes = exports.S3SourceTypes = [IMAGE_FILE, VIDEO_FILE, AUDIO_FILE, PDF_FILE];